const UMLAUTS: Record<string, string> = {ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss'};

/** "BL Herren" → "bl-herren" (keep in sync with slugify() in scripts/seo.mjs) */
export const slugify = (value: string) => value
    .toLowerCase()
    .replace(/[äöüß]/g, char => UMLAUTS[char])
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/** "/news/1179-ende-des-grunddurchgangs" – the id alone ("/news/1179") works as well. */
export const articlePath = (article: { id: number; slug?: string }) =>
    `/news/${article.id}${article.slug ? `-${article.slug}` : ''}`;

/** The post id at the start of an article address segment. */
export const articleIdFromSlug = (segment: string) => segment.match(/^\d+/)?.[0];

export const teamPath = (internalName: string) => `/teams/${slugify(internalName)}`;
